import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=41639cc6&scoped=true&"
import script from "./Score.vue?vue&type=script&lang=ts&"
export * from "./Score.vue?vue&type=script&lang=ts&"
import style0 from "./Score.vue?vue&type=style&index=0&id=41639cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41639cc6",
  null
  
)

/* custom blocks */
import block0 from "./Score.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports